import IconReviewStar from './IconReviewStar';

export const DefaultIcon = {
  component: IconReviewStar,
  props: {},
  group: 'icons',
};

export const FilledIcon = {
  component: IconReviewStar,
  props: { isFilled: true },
  group: 'icons',
};
